import { render, staticRenderFns } from "./Detalle-cc-cliente.vue?vue&type=template&id=77d54d83"
import script from "./Detalle-cc-cliente.vue?vue&type=script&lang=js"
export * from "./Detalle-cc-cliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports